export default __webpack_public_path__ + "static/media/ekitigovt.c4b36891.webp";